import { useState } from "react";
import { FileDown, FileSpreadsheet, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { download, errMsg } from "@/lib/api";
import { useFilters } from "@/context/FilterContext";

export const ExportButtons = ({ module, extra }) => {
  const { params } = useFilters();
  const [busy, setBusy] = useState(null);
  const run = async (kind) => {
    setBusy(kind);
    try {
      await download(`/export/${module}`, { ...params, ...(kind === "pdf" ? extra : {}), kind }, `laporan_${module}.${kind}`);
      toast.success(`Laporan ${kind === "pdf" ? "PDF" : "Excel"} berhasil diunduh`);
    } catch (e) {
      toast.error(`Gagal mengunduh: ${errMsg(e)}`);
    } finally {
      setBusy(null);
    }
  };
  return (
    <div className="flex gap-2">
      <Button data-testid="export-pdf-button" variant="outline" size="sm" onClick={() => run("pdf")} disabled={!!busy}>
        {busy === "pdf" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileDown className="mr-1.5 h-4 w-4" />}PDF
      </Button>
      <Button data-testid="export-excel-button" variant="outline" size="sm" onClick={() => run("xlsx")} disabled={!!busy}>
        {busy === "xlsx" ? <Loader2 className="mr-1.5 h-4 w-4 animate-spin" /> : <FileSpreadsheet className="mr-1.5 h-4 w-4" />}Excel
      </Button>
    </div>
  );
};
